import { BookingLocationType } from '@navio/nsdk';
import { cn, NoddiIcon } from 'noddi-ui-common';
import { CHANNEL_ICON, CHANNEL_LABEL } from './ChannelBadge';

type Props = {
  value: BookingLocationType;
  onChange: (channel: BookingLocationType) => void;
  /** Overrides the default channel names, e.g. when the surface needs "Mobile service" over "Mobile". */
  labels?: Partial<Record<BookingLocationType, string>>;
  className?: string;
};

// Segmented control: the selected channel lifts out of the track and takes that channel's tint,
// so which lane is on screen reads before the label does. Order is fixed — mobile leads, as it does
// as the default lane — so the control sits in the same place across a partner's departments.
const CHANNEL_ORDER = [BookingLocationType.MOBILE, BookingLocationType.STATIONARY] as const;

const ACTIVE_CHANNEL_CLASS = {
  [BookingLocationType.STATIONARY]: 'bg-channel-stationary-100 font-medium text-channel-stationary-800',
  [BookingLocationType.MOBILE]: 'bg-channel-mobile-100 font-medium text-channel-mobile-800'
} as const satisfies Record<BookingLocationType, string>;

export const ChannelSwitcher = ({ value, onChange, labels, className }: Props) => (
  <div className={cn('flex h-9 items-center gap-0.5 rounded-lg bg-[#F4F4F6] p-0.5', className)}>
    {CHANNEL_ORDER.map((channel) => (
      <button
        key={channel}
        type='button'
        aria-pressed={value === channel}
        onClick={() => onChange(channel)}
        className={cn(
          'flex h-full items-center gap-1.5 rounded-md px-3 text-sm text-grey',
          value === channel && ACTIVE_CHANNEL_CLASS[channel]
        )}
      >
        <NoddiIcon name={CHANNEL_ICON[channel]} size='small' />
        {labels?.[channel] ?? CHANNEL_LABEL[channel]}
      </button>
    ))}
  </div>
);
